import { useTranslation } from 'react-i18next';

import { ErrorAnim, MplButton, MplModal } from '@mopla/ui';

interface IDTicketPauseErrorModalProps {
	open: boolean;
	onRetry: () => void;
}

export const DTicketPauseErrorModal = ({
	open,
	onRetry,
}: IDTicketPauseErrorModalProps) => {
	const { t } = useTranslation('dticketSubscriptionPause');

	return (
		<MplModal
			open={open}
			testId="DTicketSubscriptionPause-ErrorModal"
			icon={<ErrorAnim />}
			title={t('error_modal.title')}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onRetry}
					testId="dticket-pauseErrorModal-retry-button"
				>
					{t('error_modal.button')}
				</MplButton>
			}
		/>
	);
};
